"use strict";

import Vue from "vue";
import axios from "axios";
import util from "@/util";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.withCredentials = true

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // baseURL: "https://dev-v2.bundleb2b.net/apidoc-server/app/mock/21/",
  // baseURL: "http://macausjm.mez100.com.cn/",
  baseURL: "https://bebackend.macausjm-glp.com/", // prod
  // baseURL: "http://junket.org/",
  // baseURL: "https://beadmin-qa.macausjm-glp.com", // qa
  headers: {
    // Currency: localStorage.getItem('currency') || 'MOP'
  },
  transformResponse: [
    function(data) {
      return JSON.parse(data);
    }
  ]

  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers.Lang =
      localStorage.getItem("lang") || process.env.VUE_APP_I18N_LOCALE;
    config.headers.Secret = localStorage.getItem("secret") || "";
    config.headers.Skin = localStorage.getItem("skinCode") || "glp";
    config.headers.Currency = localStorage.getItem("currency") || "MOP";
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.headers["server-time"]) {
      localStorage.date = util.dateStr(
        new Date(+response.headers["server-time"] * 1000),
        true
      );
    }
    return response.data;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
